/**
 * @fileoverview AR-670 — read-only data flows over the backend branch
 * feat-classroom-link-only-courses: the teacher's on-demand import of LEGACY
 * submissions for a project, and the files the student posted on the course
 * stream (announcements).
 *
 * Contract: mosaic-backend/docs/frontend-integration/
 * google-classroom-assignments.md
 */

import { api } from 'helpers'
import { ARC_MOSAICO_ENDPOINTS } from 'api/arcMosaico'
import { SubmissionSyncPort } from '../ports'
import { ClassroomPortError } from '../types'
import { ensureOk, normalizeError } from './httpMappers'

function toPortError(error: unknown): ClassroomPortError {
  return error instanceof ClassroomPortError ? error : normalizeError(error)
}

export const httpSubmissionSync: SubmissionSyncPort = {
  async syncSubmissions(projectId) {
    try {
      const response = await api.post(
        ARC_MOSAICO_ENDPOINTS.classroom.projectCourseSyncSubmissions(projectId),
      )
      return ensureOk(response).assignments || []
    } catch (error) {
      throw toPortError(error)
    }
  },

  async getStudentFiles(studentTaskId) {
    try {
      const response = await api.get(ARC_MOSAICO_ENDPOINTS.classroom.studentFiles(studentTaskId))
      // Unavailable is a 200 with { available: false, reason } — the caller
      // shows the reason instead of an error (contract).
      const data = ensureOk(response) || { available: false }
      return { available: Boolean(data.available), reason: data.reason, files: data.files ?? [] }
    } catch (error) {
      throw toPortError(error)
    }
  },
}
